export default __webpack_public_path__ + "static/media/sycamore1.0c6ac4da.jfif";